<template>
  <table v-if="isLoaded" :class="$style.shippingPlans">
    <thead>
      <tr>
        <th></th>
        <th nowrap>送料</th>
        <th nowrap>追跡</th>
        <th nowrap>補償</th>
        <th nowrap>
          <div :class="$style.bulkBuying">
            <span>追加送料</span>
            <IMenu width="256" title="追加送料とは？">
              <template #link>
                <QuestionIcon width="10" top="1" class="mx-2" />
              </template>
              <template #menu>
                同じショップで複数の作品を購入した場合の追加送料。<br />
                複数購入した場合の送料は「金額の高い方の送料」が適用され「その他の作品の追加送料」が加わります。
              </template>
            </IMenu>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="shippingPlan in shippingPlans" :key="shippingPlan.shippingMethodName">
        <td>{{ shippingPlan.shippingMethodName }}</td>
        <td nowrap>
          <template v-if="shippingPlan.isUniform"> &yen;{{ smallestShippingFee(shippingPlan).toLocaleString() }} </template>
          <IMenu v-else width="166" :has-underline="true">
            <template #link> &yen;{{ smallestShippingFee(shippingPlan).toLocaleString() }}〜 </template>
            <template #menu>
              <span v-for="{ areaName, fee } in shippingPlan.fees" :key="areaName">{{ areaName }} &yen;{{ fee.toLocaleString() }}<br /></span>
            </template>
          </IMenu>
        </td>
        <td :class="$style.feature">{{ shippingPlan.isTracable ? '◯' : '-' }}</td>
        <td :class="$style.feature">{{ shippingPlan.isReparative ? '◯' : '-' }}</td>
        <td nowrap>&yen;{{ shippingPlan.feeOnBulkbuying.toLocaleString() }}</td>
      </tr>
    </tbody>
  </table>
  <div v-else :class="$style.loading">
    <LoaderSvg width="32" />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { getShippingPlans, type ShippingPlanOfItem } from '@/js/lib/api/v1/item';
import IMenu from '@/js/components/molecules/IMenu.vue';
import QuestionIcon from '@/js/components/organisms/QuestionIcon.vue';
import LoaderSvg from '@/svgs/vue/loader.svg';

const props = defineProps<{
  itemId: number;
}>();
const isLoaded = ref(false);
const shippingPlans = ref<ShippingPlanOfItem[]>([]);

const smallestShippingFee = (shippingPlan: ShippingPlanOfItem) => {
  if (shippingPlan.isUniform) {
    return shippingPlan.fees[0].fee;
  }
  return Math.min(...shippingPlan.fees.map((fee) => fee.fee));
};

onMounted(async () => {
  const data = await getShippingPlans(props.itemId);
  shippingPlans.value = data.shippingPlans;
  isLoaded.value = true;
});
</script>

<style module lang="scss">
.shippingPlans {
  background-color: var(--color-white);
  border-collapse: collapse;
  width: 100%;

  th,
  td {
    font-size: 11px;
    padding: 4px 2px;
    text-align: center;
  }

  th {
    &:last-child {
      width: 62px;
    }

    .bulkBuying {
      align-items: center;
      display: flex;
    }
  }

  td:first-child {
    font-weight: bold;
    text-align: left;
  }

  td:last-child {
    padding-right: 18px;
  }

  td.feature {
    text-align: center;
  }
}

.loading {
  text-align: center;
}
</style>
